// src/features/procedures/Routes.jsx
import { Route } from 'react-router-dom';
import ProtectedRoute from '../auth/Utils/ProtectedRoute';
import ProceduresListPage from './pages/ProceduresListPage';
import CreateProcedurePage from './pages/CreateProcedurePage';
import ProcedureDetailsPage from './pages/ProcedureDetailsPage';
import EditProcedurePage from './pages/EditProcedurePage';
import ProcedureCatalogPage from './pages/ProcedureCatalog';

export const ProceduresRoutes = () => (
  <Route path="procedures">
    <Route
      index
      element={
        <ProtectedRoute requiredScope="procedure:read">
          <ProceduresListPage />
        </ProtectedRoute>
      }
    />
    <Route
      path="catalog"
      element={
        <ProtectedRoute requiredScope="procedure:create">
          <ProcedureCatalogPage />
        </ProtectedRoute>
      }
    />
    <Route
      path="create"
      element={
        <ProtectedRoute requiredScope="procedure:create">
          <CreateProcedurePage />
        </ProtectedRoute>
      }
    />
    <Route
      path=":procedureId"
      element={
        <ProtectedRoute requiredScope="procedure:read">
          <ProcedureDetailsPage />
        </ProtectedRoute>
      }
    />
    <Route
      path=":procedureId/edit"
      element={
        <ProtectedRoute requiredScope="procedure:update">
          <EditProcedurePage />
        </ProtectedRoute>
      }
    />
  </Route>
);